import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { IPatientWaitingListFiltersParamsBody, IPatientWaitingListResponse } from "@/api_framework/api_modals/Patients";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setPatientWaitingList } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
export const usePatientWaitingListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const execute = useCallback(
    async (filterParams: IPatientWaitingListFiltersParamsBody) => {
      dispatch(
        setLoading({
          key: "isPWLInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(PATIENT_WAITING_LIST?.WAITING_LIST?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPatientWaitingListResponse>) => {
            if (res.data.status === true) {
              dispatch(
                setPatientWaitingList({
                  data: res.data.data?.bookings ?? [],
                  pagination: res.data.data?.pagination ?? null,
                }),
              );
              dispatch(
                setLoading({
                  key: "isPWLInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(
                setPatientWaitingList({
                  data: [],
                  pagination: null,
                }),
              );
              dispatch(
                setLoading({
                  key: "isPWLInProgress",
                  status: false,
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            // captureError(e);
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isPWLInProgress",
                status: false,
              }),
            );
            dispatch(
              setPatientWaitingList({
                data: null,
                pagination: null,
              }),
            );
            if (e.response.status === 500) {
              toast.error("Server Error : Contact Tech Team.");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
